import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Pagination, Stack } from "@mui/material";
import "./CustomScrollbar.css";
import mathFunction from "../exams/mathFunction";
import { DataGrid, GridColDef, GridSortDirection } from "@mui/x-data-grid";
export const formatQuestion = (htmlContent: string) => {
  return htmlContent
    .replace(/font-family:\s*["']?[^;"']*["']?;?/gi, "") // Remove font-family
    .replace(/font-size:\s*["']?[^;"']*["']?;?/gi, "") // Remove font-size
    .replace(/color:\s*["']?[^;"']*["']?;?/gi, "") // Remove color
    .replace(/font-family:\s*['"]?Times New Roman['"]?;?/gi, "")
    .replace(/Times New Roman&quot;;/g, "")
    .replace(/\s*;$/g, "");
};
interface DataTableProps {
  columns: GridColDef[];
  rows: any[];
  pagination: {
    page: number;
    count: number;
    onPageChange: any;
    sort_by?: string;
    setSort_by?: (val?: string, sort?: GridSortDirection) => void;
    sort_by_type?: string;
  };
  loading: boolean;
  onRowClick?: any;
}

const ReportingTable: React.FC<DataTableProps> = ({
  columns,
  rows,
  pagination,
  loading,
  onRowClick,
}) => {
  const [page, setPage] = useState(pagination.page ?? 1);
  const { sort_by, setSort_by, sort_by_type } = pagination;
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (newPage: number) => {
    if (pagination.onPageChange) {
      pagination.onPageChange(newPage);
    }
    setPage(newPage);
  };
  useEffect(()=>{
    if(pagination.page!==page){
      // handleChangePage(pagination.page)
      
    setPage(pagination.page);
    }
  },[pagination])

  const filteredRows = rows;

  useEffect(() => {
    mathFunction();
  }, [rows, page]);

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {
        <Box
          style={{
            height: "100%",
            border: `1px solid rgba(0, 0, 0, 0.12)`,
            borderRadius: "4px",
            boxSizing: "border-box",
            // overflow: "auto",
            width: "calc(100% - 2px)",
          }}
          className="scrollBluePrimarythin"
        >
          {/* {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="350px"
            >
              <CircularProgress />
            </Box>
          ) : */}
          {filteredRows.length === 0 ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              width="100%"
            >
              No Data Found
            </Box>
          ) : (
            <Stack sx={{ width: "100%", height: "100%" }}>
              {/* overflowY:"auto" */}
              <style>{`
     .MuiDataGrid-cell {
        white-space: normal !important;
    padding: 10px !important;
    align-items: start !important;

             }
     .MuiDataGrid-columnHeaderRow {
    justify-content: flex-start !important;
  }

`}</style>
              <DataGrid
                rows={loading ? [] : filteredRows}
                columns={columns}
                pageSizeOptions={[10]}
                // loading={loading}
                paginationMode="server"
                rowCount={pagination.count}
                // paginationModel={{
                //   page: page,
                //   pageSize: 10,
                // }}
                // onPaginationModelChange={(page: any) => {
                //   handleChangePage(page);
                // }}
                pagination
                slots={{
                  pagination: (slotProps) => (
                    <Pagination
                      showFirstButton
                      showLastButton
                      {...slotProps}
                      defaultPage={page}
                      page={page}
                      count={Math.ceil(pagination.count / rowsPerPage)}
                      onChange={(event: any, newPage: number) =>
                        handleChangePage(newPage)
                      }
                    />
                  ),
                }}
                checkboxSelection={false}
                disableRowSelectionOnClick
                sortingMode="server"
                // slots={{pagination:  <Pagination count={10} showFirstButton showLastButton />}}
                sortModel={[
                  {
                    field: sort_by ?? "",
                    sort: !sort_by_type
                      ? "asc"
                      : sort_by_type === "-"
                      ? "desc"
                      : "asc",
                  },
                ]}
                disableColumnFilter
                // onRowClick={(params, event) => {
                //   console.log("Row clicked:", params.row);
                //   if (onRowClick) {
                //     onRowClick(params.row);
                //   }
                //   // You can access the row data with params.row
                //   // Do whatever you want here, e.g., open  a dialog
                // }}
                rowHeight={125}
                onSortModelChange={(newModel) => {
                  if (newModel.length === 0) {
                    //   // No sorting applied
                    if (setSort_by) {
                      setSort_by();
                    }
                  } else {
                    const field = newModel[0]?.field;
                    const type: GridSortDirection = newModel[0]?.sort;
                    if (field && setSort_by) {
                      if (setSort_by) {
                        setSort_by(field, type);
                      }
                    }
                  }
                }}
              />
            </Stack>
          )}
        </Box>
      }
    </Box>
  );
};
export default ReportingTable;
